<div *ngIf="data?.length > 0">
  <mat-paginator
    class="my-4"
    [length]="totalCount"
    [pageSize]="params.pageSize"
    [pageIndex]="params.pageNumber"
    [pageSizeOptions]="pageSizeOptions"
    showFirstLastButtons
    (page)="handlePageEvent($event)"></mat-paginator>

  <div class="overflow-auto">
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      (matSortChange)="handleSortEvent($event)"
      [matSortDisableClear]="true"
      multiTemplateDataRows>
      <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef>
          <span *ngIf="!nonSortableColumns.includes(column)" [mat-sort-header]="column">
            {{ headerLabels[column] | translate }}
          </span>

          <ng-container *ngIf="nonSortableColumns.includes(column)">
            <span class="flex text-center pl-[10px]">
              {{ headerLabels[column] | translate }}
            </span>
          </ng-container>
        </th>

        <td mat-cell *matCellDef="let row">
          <ng-container [ngSwitch]="column">
            <ng-container *ngSwitchCase="'date'">
              <div *ngIf="reports?.personOfInterestStatisticsReports?.length > 0">
                {{ row.date | date: 'yyyy-MM-dd HH:mm:ss' }}
              </div>
              <div *ngIf="!reports?.personOfInterestStatisticsReports?.length">
                {{ row.date | date: 'yyyy-MM-dd' }}
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'screenType'">
              {{ row.trackingType === 2
                ? ('reports.form.trackingValues.inbound' | translate)
                : row.trackingType === 3
                  ? ('reports.form.trackingValues.outbound' | translate)
                  : '' }}
            </ng-container>

            <ng-container *ngSwitchCase="'fileType'">
              {{ row.fileType === MediaTypeEnum.Image
                ? ('global.image' | translate)
                : row.fileType === MediaTypeEnum.Video
                  ? ('global.video' | translate)
                  : '' }}
            </ng-container>

            <ng-container *ngSwitchCase="'poiCreatedDate'">
              {{ row.createdDate | date: 'yyyy-MM-dd HH:mm:ss' }}
            </ng-container>

            <ng-container *ngSwitchCase="'smsSentTo'">
              <div class="flex items-center">
                <span *ngIf="row.hasFailurebyOfflineMode" class="mr-1">
                  <app-icon iconName="alert-triangle" size="sm" stroke="#fc4b47"></app-icon>
                </span>
                <span>{{ row.smsSentTo?.[0]?.name }}</span>
                <span class="ml-1" *ngIf="row.smsSentTo?.length > 1">
                  <a class="fl-link" (click)="openSmsSentToDialog(row.smsSentTo)">{{ 'global.more' | translate }}</a>
                </span>
              </div>
            </ng-container>

            <ng-container *ngSwitchDefault>
              {{ row[column] ?? '-' }}
            </ng-container>
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row class="bg-gray-50" *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns; let odd = odd" [ngClass]="odd ? 'bg-gray-50' : 'bg-white'"></tr>
    </table>
  </div>
</div>

<ng-container *ngIf="data?.length === 0">
  <flow-no-data [label]="'global.noDataFoundInfo'"></flow-no-data>
</ng-container>
